import { Box, Typography } from '@mui/material';
import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  description: string;
  value?: string | number;
};

export const TextRowItem = ({ description, value }: Props) => {
  const isMobile = useResponsive('down', 'md');
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '8px',
      }}
    >
      <Typography sx={{ fontSize: '14px' }}>{description}</Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: '700' }}>{value}</Typography>
    </Box>
  );
};
